import React, { useState } from "react";
import PortalPublications from "./PortalPublications";

function EmulateClinical() {
  const id = "emulate-clinical-publications";
  const inpRef = React.useRef(null);
  const [props, setProps] = useState(JSON.parse(localStorage.getItem(id)));

  function submit() {
    const conf = inpRef.current.value;
    localStorage.setItem(id, conf);
    setProps({ ...JSON.parse(conf) });
  }

  return (
    <>
      <textarea
        ref={inpRef}
        onKeyDown={(e) => {
          if (e.code === "Enter" && e.ctrlKey) submit();
        }}
        className="tw-w-full"
        type="text-area"
        defaultValue={JSON.stringify(props)}
      />

      <div>{JSON.stringify(props, null, 2)}</div>

      <PortalPublications {...props} />
    </>
  );
}

export default EmulateClinical;
